import * as React from "react";
import {css, cx} from "emotion";

import "./view-type.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {GridViewSvg} from './grid-view-svg';
import {ListViewSvg} from './list-view-svg';

export const ViewType = ({viewType}) => cs(
    consumeContext("themeScheme"),
    ({themeScheme}) => (
        <div className="view-type view-type-1ee">
            <div
                className={cx("type", {active: viewType.value === "list"},
                    css`
                        &.active {
                          background: ${themeScheme.xpresso.menuBackgroundColorShadow};
                        }
                    `
                )}
                onClick={() => viewType.onChange("list")}
                xd-qa-type="icon"
                xd-qa-name="list_view"
            >
                <ListViewSvg
                    fill={viewType.value === "list" ? "white" : themeScheme.xpresso.menuBackgroundColorShadow}
                    fillOpacity= {undefined}
                />
            </div>
            <div
                className={cx("type", {active: viewType.value === "grid"},
                    css`
                        &.active {
                          background: ${themeScheme.xpresso.menuBackgroundColorShadow};
                        }
                    `
                )}
                onClick={() => viewType.onChange("grid")}
                xd-qa-type="icon"
                xd-qa-name="grid_view"
            >
                <GridViewSvg
                    fill={viewType.value === "grid" ? "white" : themeScheme.xpresso.menuBackgroundColorShadow}
                    fillOpacity= {undefined}
                />
            </div>
        </div>
    )
);
